import React, { useRef, useState, useEffect } from "react";
import "./FileUploader.styles.scss";

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 1000;

export default function FileUploader({
  label,
  updateFilesCb,
  maxSize = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  multiple = false,
  documentType,
}) {
  //La funcionalidad de camara esta habilidatada solamente cuando el documentType = "Image"
  // updateFilesCb es una funcion que actualiza los datos en la pantalla que se utilice el FileUploader,
  // por ejemplo:
  // const updateUploadedFiles = (files) =>
  //   setClasificacion({ ...Object, Files: files });
  const fileInput = useRef(null);
  const videoRef = useRef(null);
  const photoRef = useRef(null);
  const [files, setFiles] = useState({});
  const [filesLabel, setFilesLabel] = useState("");
  const [useVideo, setUseVideo] = useState(false);

  useEffect(() => {
    if (useVideo) {
      getVideo();
    }
  }, [videoRef]);

  const convertNestedObjectToArray = (nestedObj) =>
    Object.keys(nestedObj).map((key) => nestedObj[key]);

  const callUpdateFilesCb = (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray);
  };

  const handleUploadBtnClick = () => {
    fileInput.current.click();
  };

  const handleNewFileUpload = (e, photo = null) => {
    const { files: newFiles } = e.target;
    if (newFiles.length || photo !== null) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      if (!multiple) {
        setFilesLabel(updatedFiles.file.name);
      } else {
        updateLabel();
      }
      callUpdateFilesCb(updatedFiles);
    }
  };
  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxSize) {
        if (!multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const getVideo = () => {
    navigator.mediaDevices
      .getUserMedia({ video: { width: 300 } })
      .then((stream) => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch((err) => {
        console.error("error:", err);
      });
  };
  const paintToCanvas = () => {
    let video = videoRef.current;
    let photo = photoRef.current;
    let ctx = photo.getContext("2d");

    const width = 300;
    const height = 200;
    photo.width = width;
    photo.height = height;
    ctx.drawImage(video, 0, 0, width, height);
  };

  const uploadPhoto = () => {
    let photo = photoRef.current;
    const data = photo.toDataURL("image/jpeg");
    let blob = dataURLtoBlob(data);
    var file = new File([blob], "photo.jpeg");
    let updatedFiles = addNewFiles([file]);
    setFiles(updatedFiles);
    if (!multiple) {
      setFilesLabel(updatedFiles.file.name);
    } else {
      updateLabel();
    }
    callUpdateFilesCb(updatedFiles);
  };

  const updateLabel = () => {
    if (!multiple) return;
    let nameArray = [];
    setFiles(files);
    for (const name in files) {
      nameArray.push(name);
    }
    setFilesLabel(nameArray.join(", "));
  };

  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  const handleUseVideo = () => {
    if (useVideo) {
      setUseVideo(false);
    } else {
      setUseVideo(true);
      getVideo();
    }
  };
  return (
    <div>
      <div className="row FileUploadContainer">
        <button
          className="StyledUploadButton"
          type="button"
          onClick={handleUploadBtnClick}
        >
          <i className="fas fa-file-upload" />
          {filesLabel && filesLabel != "" ? (
            <div>
              <span className="UploaderText">{filesLabel}</span>
            </div>
          ) : (
            <span>{label}</span>
          )}
        </button>
        <input
          ref={fileInput}
          type="file"
          multiple={multiple}
          title=""
          value=""
          onChange={handleNewFileUpload}
          className="HiddenFileUpload"
        ></input>
        {documentType === "Image" ? (
          <div>
            <button
              type="button"
              className="OpenCameraButton"
              onClick={handleUseVideo}
            >
              <i className="fas fa-camera"></i>
            </button>
          </div>
        ) : null}
      </div>
      {useVideo === true ? (
        <div className="container-fluid photoContainer">
          <div className="row">
            <div className="webcam-video">
              <video ref={videoRef} className="player" />
            </div>
            <canvas ref={photoRef} className="photo" />
          </div>
          <div className="row">
            <button
              className="TakePictureButton"
              type="button"
              onClick={() => paintToCanvas()}
            >
              <i className="fas fa-image"></i>
            </button>
            <button
              className="TakePictureButton"
              type="button"
              onClick={uploadPhoto}
            >
              <i className="fas fa-upload"></i>
            </button>
          </div>
        </div>
      ) : (
        false
      )}
    </div>
  );
}
